
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, from, map, of, switchMap } from 'rxjs';
import { IPaymentCreditFormExt, LGEDataService } from 'src/commons';

import {
  PaymentCreditActionTypes,
  LoadPaymentCreditStateFail,

  LoadPaymentCreditFormCCState,
  LoadPaymentCreditFormCCStateSuccess,
  LoadProcessedPaymentCreditFormCCState,
  LoadProcessedPaymentCreditFormCCStateSuccess,

  LoadPaymentCreditFormCGState,
  LoadPaymentCreditFormCGStateSuccess,
  LoadProcessedPaymentCreditFormCGState,
  LoadProcessedPaymentCreditFormCGStateSuccess,

  LoadPaymentCreditFormPPState,
  LoadPaymentCreditFormPPStateSuccess,
  LoadProcessedPaymentCreditFormPPState,
  LoadProcessedPaymentCreditFormPPStateSuccess,

  LoadPaymentCreditFormESState,
  LoadPaymentCreditFormESStateSuccess,
  LoadProcessedPaymentCreditFormESState,
  LoadProcessedPaymentCreditFormESStateSuccess,

  ProcessFormCCAsCredit,
  ProcessFormExtAsCredit,

  // LoadPaymentCreditFormCIState,
  // LoadPaymentCreditFormCIStateSuccess,
  // LoadProcessedPaymentCreditFormCIState,
  // LoadProcessedPaymentCreditFormCIStateSuccess,
} from './payment-credit.actions';

@Injectable()
export class PaymentCreditEffects {
  private pendingCC: any = {};
  private processedCC: any = {};

  private pendingExt: any = {};
  private processedExt: any = {};

  constructor(
    private actions$: Actions,
    private lgeData: LGEDataService
  ) {
    this.pendingExt.statusId = '3';
    this.pendingExt.paymentMethod = 'CREDIT';

    this.processedExt.statusId = '17';
    this.processedExt.paymentMethod = 'CREDIT';

    this.pendingCC.statusId = '5';
    this.pendingCC.paymentMethod = 'CREDIT';

    this.processedCC.statusId = '3';
    this.processedCC.paymentMethod = 'CREDIT';
  }

  // formCC
  loadPaymentCreditFormCCState$ = createEffect(
    () => this.actions$.pipe(
      ofType(PaymentCreditActionTypes.LoadPaymentCreditFormCCState),
      switchMap(
        () => this.lgeData.GetFormCCForPaymentAsCredit(this.pendingCC)
      ),
      switchMap(rq => [new LoadPaymentCreditFormCCStateSuccess(rq),
      new LoadProcessedPaymentCreditFormCCState()]),
      catchError(error => of(new LoadPaymentCreditStateFail(error)))
    )
  )

  loadProcessedPaymentCreditFormCCState$ = createEffect(
    () => this.actions$.pipe(
      ofType(PaymentCreditActionTypes.LoadProcessedPaymentCreditFormCCState),
      switchMap(
        () => from(this.lgeData.GetFormCCForPaymentAsCredit(this.processedCC)).pipe(
          map(rq => new LoadProcessedPaymentCreditFormCCStateSuccess(rq)),
          catchError(error => of(new LoadPaymentCreditStateFail(error)))
        )
      )
    )
  )

  // formCG

  loadPaymentCreditFormCGState$ = createEffect(
    () => this.actions$.pipe(
      ofType(PaymentCreditActionTypes.LoadPaymentCreditFormCGState),
      switchMap(
        () => this.lgeData.GetFormCGForPaymentAsCredit(this.pendingExt)
      ),
      switchMap((rq: IPaymentCreditFormExt) => [new LoadPaymentCreditFormCGStateSuccess(rq),
      new LoadProcessedPaymentCreditFormCGState()]),
      catchError(error => of(new LoadPaymentCreditStateFail(error)))
    )
  )

  loadProcessedPaymentCreditFormCGState$ = createEffect(
    () => this.actions$.pipe(
      ofType(PaymentCreditActionTypes.LoadProcessedPaymentCreditFormCGState),
      switchMap(
        () => from(this.lgeData.GetFormCGForPaymentAsCredit(this.processedExt)).pipe(
          map(rq => new LoadProcessedPaymentCreditFormCGStateSuccess(rq)),
          catchError(error => of(new LoadPaymentCreditStateFail(error)))
        )
      )
    )
  )

  // formPP

  loadPaymentCreditFormPPState$ = createEffect(
    () => this.actions$.pipe(
      ofType(PaymentCreditActionTypes.LoadPaymentCreditFormPPState),
      switchMap(
        () => this.lgeData.GetFormPPForPaymentAsCredit(this.pendingExt)
      ),
      switchMap((rq: IPaymentCreditFormExt) => [new LoadPaymentCreditFormPPStateSuccess(rq),
      new LoadProcessedPaymentCreditFormPPState()]),
      catchError(error => of(new LoadPaymentCreditStateFail(error)))
    )
  )

  loadProcessedPaymentCreditFormPPState$ = createEffect(
    () => this.actions$.pipe(
      ofType(PaymentCreditActionTypes.LoadProcessedPaymentCreditFormPPState),
      switchMap(
        () => from(this.lgeData.GetFormPPForPaymentAsCredit(this.processedExt)).pipe(
          map(rq => new LoadProcessedPaymentCreditFormPPStateSuccess(rq)),
          catchError(error => of(new LoadPaymentCreditStateFail(error)))
        )
      )
    )
  )

  // formES
  loadPaymentCreditFormESState$ = createEffect(
    () => this.actions$.pipe(
      ofType(PaymentCreditActionTypes.LoadPaymentCreditFormESState),
      switchMap(
        () => this.lgeData.GetFormESForPaymentAsCredit(this.pendingExt)
      ),
      switchMap((rq: IPaymentCreditFormExt) => [new LoadPaymentCreditFormESStateSuccess(rq),
      new LoadProcessedPaymentCreditFormESState()]),
      catchError(error => of(new LoadPaymentCreditStateFail(error)))
    )
  )

  loadProcessedPaymentCreditFormESState$ = createEffect(
    () => this.actions$.pipe(
      ofType(PaymentCreditActionTypes.LoadProcessedPaymentCreditFormESState),
      switchMap(
        () => from(this.lgeData.GetFormESForPaymentAsCredit(this.processedExt)).pipe(
          map(rq => new LoadProcessedPaymentCreditFormESStateSuccess(rq)),
          catchError(error => of(new LoadPaymentCreditStateFail(error)))
        )
      )
    )
  )

  // other

  processFormCCAsCredit$ = createEffect(
    () => this.actions$.pipe(
      ofType(PaymentCreditActionTypes.ProcessFormCCAsCredit),
      map((action: ProcessFormCCAsCredit) => action.payload),
      switchMap(
        (request) => from(this.lgeData.UpdateFormCCForPaymentAsCredit(request)).pipe(
          map(() => new LoadPaymentCreditFormCCState()),
          catchError(error => of(new LoadPaymentCreditStateFail(error)))
        )
      )
    )
  )

  processFormExtAsCredit$ = createEffect(
    () => this.actions$.pipe(
      ofType(PaymentCreditActionTypes.ProcessFormExtAsCredit),
      map((action: ProcessFormExtAsCredit) => action.payload),
      switchMap(
        (requests) => from(this.lgeData.UpdateFormExtForPaymentAsCredit(requests)).pipe(
          map(() => {
            switch (requests.requestNumber.substring(0, 2)) {
              case 'CG':
                return new LoadPaymentCreditFormCGState();
              case 'PP':
                return new LoadPaymentCreditFormPPState();
              case 'ES':
                return new LoadPaymentCreditFormESState();
              default:
                return new LoadPaymentCreditStateFail('');
              // case 'CI':
              //   return new LoadPaymentCreditFormCIState();
            }
          }),
          catchError(error => of(new LoadPaymentCreditStateFail(error)))
        )
      )
    )
  )
  // @Effect()
  // processFormExtAsCredit$: Observable<Action> = this.actions$
  //   .ofType(PaymentCreditActionTypes.ProcessFormExtAsCredit)
  //   .map((action: ProcessFormExtAsCredit) => action.payload)
  //   .switchMap((requests) =>
  //     Observable.fromPromise(this.lgeData.UpdateFormExtForPaymentAsCredit(requests))
  //       .map(() => {
  //         switch (requests.requestNumber.substring(0, 2)) {
  //           case 'CG':
  //             return new LoadPaymentCreditFormCGState();
  //           case 'PP':
  //             return new LoadPaymentCreditFormPPState();
  //           case 'ES':
  //             return new LoadPaymentCreditFormESState();
  //           // case 'CI':
  //           //   return new LoadPaymentCreditFormCIState();
  //         }
  //       })
  //       .catch(error => Observable.of(new LoadPaymentCreditStateFail(error)))
  //   );

}


